<div class="btn-toolbar btn-max-content gap-1 justify-content-end" *transloco="let t; read: 'ime.components.action-bar'">
  <ng-content></ng-content>
  <button *ngIf="forceSave && (isForceSaveShown$ | async)" type="button" class="btn btn-outline-warning btn-sm me-1"
          (click)="forceSave.emit()">
    <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#cloud-arrow-up'">
    </svg>
    {{t('Force Save')}}
  </button>
  <ng-container *ngLet="(saveState$ | async) as hasChanges">
    <button type="button" class="btn btn-outline-primary btn-sm me-1 position-relative" *ngIf="showSave" (click)="save.emit()">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#cloud-arrow-up'">
      </svg>
      {{t('Save')}}
      <span *ngIf="hasChanges" class="position-absolute top-0 start-100 translate-middle p-1 bg-primary border border-light rounded-circle"></span>
    </button>
  </ng-container>
  <ng-container *ngLet="(deleteState$ | async) as isEnabled">
    <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="showDelete"
            [disabled]="!isEnabled"
            (click)="deleteClicked()">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#trash'">
      </svg>
      {{t('Delete')}}
    </button>
  </ng-container>
</div>
